module.exports = __webpack_public_path__ + "750acf164df2523d5af49c45a1c747b0.png";


//////////////////
// WEBPACK FOOTER
// ./work/swipolitique/img/ranking.png
// module id = 761
// module chunks = 0